// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__KUOVQ","list":"PatternAutocomplete_list__34dAi"};